import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import Table, { useTable } from 'common/components/table';
import moment from 'moment';

import TableActions from 'components/layouts/table';

import edit from 'assets/svg/actions/edit.svg';

import useDrawer from 'common/components/drawer/useDrawer';
import Form from './form';
import EnumsDropdown from '../Dropdown';

const LdTerms = () => {
  const [active, setActive] = useState(null);

  const drawer = useDrawer();

  const table = useTable({
    label: 'ld_terms',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: false,
        canFilter: false
      },
      {
        header: 'Description',
        key: 'description',
        type: 'string',
        sort: false,
        canFilter: false
      },
      {
        header: 'Multiplier',
        key: 'multiplier',
        type: 'string',
        sort: false,
        canFilter: false
      },
      {
        header: 'Working Start Day',
        key: 'start_day',
        type: 'string',
        sort: false,
        canFilter: false
      },
      {
        header: 'Time',
        key: 'start_time',
        type: 'string',
        sort: false,
        canFilter: false
      },
      {
        header: 'Working End Day',
        key: 'end_day',
        type: 'string',
        sort: false,
        canFilter: false
      },
      {
        header: 'Time',
        key: 'end_time',
        type: 'string',
        sort: false,
        canFilter: false
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center',
        width: 1
      }
    ]
  });

  return (
    <Row className="ld_terms-table">
      <Col xs={12} className="mb-6 mt-n1">
        <TableActions
          documentTitle="LD Terms"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[
            { type: 'search' },
            {
              type: 'add',
              text: 'Add Terms',
              color: 'primary',
              onClick: () => {
                setActive(null);
                drawer.open();
              }
            }
          ]}
        />
      </Col>

      <Col xs={12}>
        <Table
          loader
          drawer={<Form drawer={drawer} active={active} />}
          rows={{
            start_day: data => moment().day(data.start_day).format('dddd'),
            end_day: data => moment().day(data.end_day).format('dddd'),
            actions: () => ({
              options: [
                {
                  label: 'Edit',
                  icon: edit,
                  onClick: (_, row) => {
                    setActive(row);
                    drawer.open();
                  }
                }
              ]
            })
          }}
          {...table}
        />
      </Col>
    </Row>
  );
};

export default LdTerms;
